import { GroupingRule, WithTransactionId } from '@ardoq/api-types';
import {
  AddGroupingRulesPayload,
  SetGroupingRulesPayload,
  addGroupingRules,
  clearGroupingRules,
  setGroupingRules,
} from './GroupingActions';
import { persistentReducedStream, reducer } from '@ardoq/rxbeach';

export type GroupingRulesState = WithTransactionId & {
  groupingRules: GroupingRule[];
};

const emptyState: GroupingRulesState = {
  groupingRules: [],
  transactionId: undefined,
};

const setGroupingRulesReducer = (
  _state: GroupingRulesState,
  { groupingRules, transactionId }: SetGroupingRulesPayload
): GroupingRulesState => ({
  groupingRules,
  transactionId,
});

// addGroupingRules appends to existing rules. If `transactionId` is provided
// in the payload, it overrides; otherwise the prior transactionId is kept (so
// a clear-then-add sequence stays in one logical transaction).
const addGroupingRulesReducer = (
  state: GroupingRulesState,
  { groupingRules, transactionId }: AddGroupingRulesPayload
): GroupingRulesState => ({
  groupingRules: [...state.groupingRules, ...groupingRules],
  transactionId: transactionId ?? state.transactionId,
});

const clearGroupingRulesReducer = (): GroupingRulesState => emptyState;

export const groupingRules$ = persistentReducedStream<GroupingRulesState>(
  'groupingRules$',
  emptyState,
  [
    reducer(setGroupingRules, setGroupingRulesReducer),
    reducer(addGroupingRules, addGroupingRulesReducer),
    reducer(clearGroupingRules, clearGroupingRulesReducer),
  ]
);
